<template>
  <div>
    <template v-if="solution.length > 0">
      <div class="math">
	
	<table v-if="exp==0" class="matrix">
	  <tr v-for="(v,j) in solution" :key="'v' + j">
	    <td> <Variable :config="config" :index="j"></Variable></td>
	    <td> = </td>
	    <td v-for="(e,k) in v" :key="'e' + j + '_' + k">
	      {{ coeff[j][k] }}
	      <span v-if="showConstant[j][k]">
		{{ config.constant }}<sub>{{k+1}}</sub>	      
	      </span>
	    </td>
	  </tr>
	</table>

	<template v-if="exp==1">
	  <table class="matrix">
	    <tr>
	      <td class="leftp" :rowspan="solution.length+2"></td>
	      <td class="dummy" :rowspan="solution.length+2"></td>
	      <td class="dummy" ></td>
	      <td class="dummy" :rowspan="solution.length+2"></td>
	      <td class="rightp" :rowspan="solution.length+2"></td>
	    </tr>
	    <tr v-for="(r,k) in solution" :key="'v'+k">
	      <td> <Variable :config="config" :index="k"></Variable></td>
	    </tr>
	    <tr>
	      <td class="dummy" ></td>
	    </tr>
	  </table>
	  <span class="equal">=</span>
	  <table class="matrix">
	    <tr>
	      <td class="leftp" :rowspan="solution.length+2"></td>
	      <td class="dummy" :rowspan="solution.length+2"></td>
	      <td class="dummy" ></td>
	      <td class="dummy" :rowspan="solution.length+2"></td>
	      <td class="rightp" :rowspan="solution.length+2"></td>
	    </tr>
	    <tr v-for="(r,j) in solution" :key="'v'+j">
	      <td class="center">
		<span v-for="(e,k) in r" :key="'e' + j + '_' + k">
		  {{ coeff[j][k] }}
		  <span v-if="showConstant[j][k]">
		    {{ config.constant }}<sub>{{k+1}}</sub>	      
		  </span>
		</span>
	      </td>
	    </tr>
	    <tr>
	      <td class="dummy" ></td>
	    </tr>
	  </table>	
	</template>

	<template v-if="exp==2" class="math">
	  <table class="matrix">
	    <tr>
	      <td class="leftp" :rowspan="solution.length+2"></td>
	      <td class="dummy" :rowspan="solution.length+2"></td>
	      <td class="dummy" ></td>
	      <td class="dummy" :rowspan="solution.length+2"></td>
	      <td class="rightp" :rowspan="solution.length+2"></td>
	    </tr>
	    <tr v-for="(r,k) in solution" :key="'v'+k">
	      <td> <Variable :config="config" :index="k"></Variable></td>
	    </tr>
	    <tr>
	      <td class="dummy" ></td>
	    </tr>
	  </table>
	  <span class="equal">=</span>
	  <template v-for="(f,k) in solution[0]">
	    <span v-if="k>0" :key="'plus'+k">+</span>
	    <span v-if="k<solution[0].length-1"  :key="'const'+k">
	      {{ config.constant }}<sub>{{k+1}}</sub>	      
	    </span>
	    <table class="matrix"  :key="'vector'+k">
	      <tr>
		<td class="leftp" :rowspan="solution.length+2"></td>
		<td class="dummy" :rowspan="solution.length+2"></td>
		<td class="dummy" ></td>
		<td class="dummy" :rowspan="solution.length+2"></td>
		<td class="rightp" :rowspan="solution.length+2"></td>
	      </tr>
	      <tr v-for="(r,j) in solution" :key="'v'+j">
		<td class="center"> {{ solution[j][k].toFraction() }} </td>
	      </tr>
	      <tr>
		<td class="dummy" ></td>
	      </tr>
	    </table>	  
	  </template>
	</template>

	<span class="note" v-if="solution[0].length > 1">
	  (
	  <span v-for="j in solution[0].length-1" :key="'const'+j">
	    {{ config.constant }}<sub>{{j}}</sub> <span v-if="j<solution[0].length-1">,</span>
	  </span>
	  は任意の数)
	</span>
      </div>
      
      <p>
	<button @click="exp = (exp+1) % 3"> 表示切替 </button>
      </p>
    </template>
    <p v-else>
      解なし
    </p>
  </div>
</template>

<script>
import { Config, zero, one, minus } from '@/lib/base.js';
import { Matrix } from '@/lib/reduce.js';
import Variable from '@/components/Variable.vue'

export default {
  name: 'Solution',
  components: {
    Variable
  },
  props: {
    matrix: Matrix,
    config: Config
  },
  data: function(){
    return {
      exp: 0,
      solution: [],
      coeff: [],
      showConstant: []
    };
  },
  created: function(){
    const varConst = new Array(this.matrix.cols-1).fill(-1);
    const varRow = new Array(this.matrix.cols-1).fill(-1);
    const constCol = [];
    for(let i=0; i< this.matrix.rows;i++){
      const p = this.matrix.matrix[i].findIndex( (e) => e.equals(one) );
      if(p>=0){
	if(p == this.matrix.cols-1){
	  return;
	}
	varRow[p] = i;
      }
    }
    for(let j=0; j<this.matrix.cols-1;j++){
      if(varRow[j] == -1){
	varConst[j] = constCol.length;
	constCol.push(j);
      }
    }
    const width = constCol.length + 1;
    for(let j=0; j<this.matrix.cols-1;j++){
      const row = new Array(width).fill(zero);
      const rowC = new Array(width).fill('');
      const rowS = new Array(width).fill(false);
      if(varConst[j] >= 0){
	row[varConst[j]] = one;
	rowS[varConst[j]] = true;
      }else{
	for(let k=0;k<width;k++){
	  const f = k == width-1 ? this.matrix.matrix[varRow[j]][this.matrix.cols-1] : this.matrix.matrix[varRow[j]][constCol[k]].neg();
	  row[k] = f;
	  if(! f.equals(zero)){
	    if(k < width-1){
	      rowS[k] = true;
	    }
	    let sign = f.s > 0 ? ( row.findIndex( (e) => ! e.equals(zero) ) == k ? '' : '+ ') : '- ';	
	    if(k < width-1 && (f.equals(one) || f.equals(minus))){
	      rowC[k] = sign;
	    }else if(k < width-1 && f.d > 1){
	      rowC[k] = sign + '(' + f.abs().toFraction() + ')';
	    }else{
	      rowC[k] = sign + f.abs().toFraction();
	    }
	  }
	}
	if(row.every( (e) => e.equals(zero) )){
	  rowC[width-1] = '0';
	}
      }
      this.solution.push(row);
      this.coeff.push(rowC);
      this.showConstant.push(rowS);
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.note {
    margin-left:50px;
}
.center {
    text-align: center;
}
.equal {
    margin-left: 10px;
    margin-right:10px;
}
</style>
